/**
 * product-personalization.js  v6
 * Pera Atelier — Product Personalization
 * Fix: font overlay showing wrong font — @font-face name vs data-font-family mismatch
 */

(function () {
  'use strict';

  /* ─── STATE ──────────────────────────────────── */
  var isPersonalized = true;   /* always personalized */
  var canShowPreview = true;

  /* ─── PREVIEW OVERLAY (module-level) ─────────── */
  var previewEl  = null;
  var prevIconEl = null;
  var prevTextEl = null;

  /* ─── FONT MAP (fallback for metafield fonts) ── */
  var FONT_MAP = {
    'Classic Script': { css: "'Pinyon Script', cursive",     url: 'https://fonts.googleapis.com/css2?family=Pinyon+Script&display=swap' },
    'Modern Serif':   { css: "'Playfair Display', serif",    url: 'https://fonts.googleapis.com/css2?family=Playfair+Display&display=swap' },
    'Bold Block':     { css: "'Oswald', sans-serif",         url: 'https://fonts.googleapis.com/css2?family=Oswald:wght@500&display=swap' },
    'Elegant Italic': { css: "'Cormorant Garamond', serif",  url: 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond&display=swap' },
    'Handwritten':    { css: "'Dancing Script', cursive",    url: 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@600&display=swap' },
    'Sans Modern':    { css: "'Montserrat', sans-serif",     url: 'https://fonts.googleapis.com/css2?family=Montserrat:wght@300&display=swap' }
  };
  var _loadedFonts = {};
  function loadGFont(lbl, url) {
    if (!url || _loadedFonts[lbl]) return;
    _loadedFonts[lbl] = true;
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = url;
    document.head.appendChild(l);
  }

  /* ─── @FONT-FACE REGISTRY ────────────────────────
   * Build a lookup: lowercase(font.family) → exact registered font-family name
   * Shopify's font_face filter uses the font.family value verbatim in @font-face.
   * We normalise to lowercase for matching since CSS font-family is case-insensitive
   * but browser font-family lookup is done on the exact registered string.
   * Reading from CSSFontFaceRule gives us the precise registered name.
   * ────────────────────────────────────────────── */
  var _fontFaceRegistry = null; // { 'bagel fat one': 'Bagel Fat One', ... }

  function buildFontFaceRegistry() {
    if (_fontFaceRegistry) return _fontFaceRegistry;
    _fontFaceRegistry = {};
    try {
      Array.from(document.styleSheets).forEach(function (ss) {
        try {
          Array.from(ss.cssRules || []).forEach(function (rule) {
            if (rule instanceof CSSFontFaceRule) {
              var name = rule.style.getPropertyValue('font-family');
              if (name) {
                // Strip surrounding quotes (both single and double)
                var clean = name.replace(/^["']|["']$/g, '').trim();
                _fontFaceRegistry[clean.toLowerCase()] = clean;
              }
            }
          });
        } catch (e) { /* cross-origin sheet — skip */ }
      });
    } catch (e) {}
    return _fontFaceRegistry;
  }

  /**
   * Resolve the exact @font-face-registered name for a font.
   * Falls back to the raw value if no match found.
   * @param {string} rawFamily  — value from data-font-family attribute
   * @returns {string}          — safe CSS font-family string (quoted)
   */
  function resolveFontCss(rawFamily) {
    if (!rawFamily) return 'Georgia, serif';
    var registry = buildFontFaceRegistry();
    var key = rawFamily.toLowerCase();
    var resolved = registry[key] || rawFamily;
    // Always use double quotes to match @font-face declarations
    return '"' + resolved + '", serif';
  }

  /* ═══════════════════════════════════════════════
     MAIN INIT — called on load AND after section reload
  ═══════════════════════════════════════════════ */
  function init() {
    var root = document.getElementById('PdpPersonalization');
    if (!root) return;

    /* Config from data attributes */
    var feePrice     = parseInt(root.dataset.feePrice  || '0', 10);
    var feeVariantId = root.dataset.feeVariant || '';
    var charLimit    = parseInt(root.dataset.charLimit || '30', 10);
    var basePrice    = parseInt(root.dataset.basePrice || '0', 10);

    /* DOM refs — always fresh */
    var panel         = document.getElementById('PersPanel');
    var iconPicker    = document.getElementById('PdpIconPicker');
    var iconNameEl    = document.getElementById('PersIconName');
    var iconInput     = document.getElementById('PersIcon');
    var fontPicker    = document.getElementById('PdpFontPicker');
    var colorPicker   = document.getElementById('PdpColorPicker');
    var colorNameEl   = document.getElementById('PersColorName');
    var textInput     = document.getElementById('PersText');
    var charCountEl   = document.getElementById('PersCharCount');
    var hintEl        = document.getElementById('PersHint');
    var fontInput     = document.getElementById('PersFont');
    var colorInput    = document.getElementById('PersColor');
    var feeIdInput    = document.getElementById('PersFeeId');
    var feePriceInput = document.getElementById('PersFeePrice');
    var modeInput     = document.getElementById('PersModeInput');
    var priceBreakdown = document.getElementById('PersPriceBreakdown');
    var basePriceEl   = document.getElementById('PersBasePrice');
    var feeTotalEl    = document.getElementById('PersTotal');
    var form          = document.getElementById('ProductForm');
    var mainImgWrap   = document.querySelector('.pdp-main-img');

    /* ─── CURRENCY ───────────────────────────────── */
    var currencyCode = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AED';
    function formatMoney(cents) {
      try { return new Intl.NumberFormat('en-AE', { style: 'currency', currency: currencyCode, minimumFractionDigits: 2 }).format(cents / 100); }
      catch (e) { return currencyCode + ' ' + (cents / 100).toFixed(2); }
    }

    /* ─── PREVIEW OVERLAY ────────────────────────── */
    /* Reset refs so they attach to current DOM */
    previewEl = null; prevIconEl = null; prevTextEl = null;
    document._persColorHex = '';  /* reset on re-init */

    if (mainImgWrap) {
      /* Remove any orphaned overlay from previous init */
      var old = mainImgWrap.querySelector('.pdp-pers-preview');
      if (old) old.parentNode.removeChild(old);

      /* Inject styles once */
      if (!document.getElementById('PdpPersPreviewStyles')) {
        var s = document.createElement('style');
        s.id = 'PdpPersPreviewStyles';
        s.textContent = [
          '.pdp-main-img { position: relative !important; overflow: hidden; }',
          '.pdp-pers-preview { position: absolute; top: 50%; left: 50%; transform: translate(-50%,-62%); z-index: 12; display: flex; flex-direction: column; align-items: center; gap: .6rem; pointer-events: none; opacity: 0; transition: opacity .35s ease; text-align: center; max-width: 70%; }',
          '.pdp-pers-preview.is-visible { opacity: 1; }',
          '.pdp-pers-preview__icon { line-height: 1; filter: drop-shadow(0 2px 6px rgba(0,0,0,.25)); transition: color .3s; }',
          '.pdp-pers-preview__text { line-height: 1.2; letter-spacing: .06em; white-space: nowrap; transition: color .3s, font-family .3s; text-shadow: 0 1px 4px rgba(0,0,0,.3); }'
        ].join('\n');
        document.head.appendChild(s);
      }

      previewEl  = document.createElement('div');
      previewEl.className = 'pdp-pers-preview';
      previewEl.setAttribute('aria-hidden', 'true');

      prevIconEl = document.createElement('span');
      prevIconEl.className = 'pdp-pers-preview__icon';

      prevTextEl = document.createElement('span');
      prevTextEl.className = 'pdp-pers-preview__text';

      previewEl.appendChild(prevIconEl);
      previewEl.appendChild(prevTextEl);
      mainImgWrap.appendChild(previewEl);
    }

    /* ─── UPDATE PREVIEW ─────────────────────────── */
    /*
     * FONT RENDERING STRATEGY (v7 — CSS block-ID):
     * Liquid generates per-block CSS rules:
     *   .pdp-pers-preview__text[data-font-block="<id>"] { font-family: ...; }
     * JS sets data-font-block attribute → CSS activates the matching rule.
     * JS only controls: font-size (px) and color.
     * This eliminates all JS font-family string reconstruction / quote mismatch bugs.
     */
    function updatePreview() {
      if (!previewEl) return;

      var iconSymbol = '';
      var colorHex   = '';
      var fontSize   = 28;
      var text       = textInput ? textInput.value : '';
      var blockId    = '';

      /* ── Icon ── */
      var iconType    = 'none';  // 'none' | 'emoji' | 'image'
      var iconUrl     = '';
      var iconSizePx  = 0;
      if (iconPicker) {
        var si = iconPicker.querySelector('.pdp-pers__icon-card.is-selected');
        if (si) {
          iconType   = si.dataset.iconType   || 'emoji';
          iconSymbol = si.dataset.iconSymbol || '';
          iconUrl    = si.dataset.iconUrl    || '';
          iconSizePx = parseInt(si.dataset.iconSize || '0', 10) || 0;
        }
      }

      /* ── Color ── */
      /* Use module-level persColorHex (set by both swatch clicks and free picker) */
      colorHex = document._persColorHex || '';
      if (!colorHex && colorPicker) {
        var sc = colorPicker.querySelector('.pdp-pers__color-swatch.is-selected');
        colorHex = sc ? (sc.dataset.colorHex || '') : '';
      }

      /* ── Font ── */
      if (fontPicker) {
        var sf = fontPicker.querySelector('.pdp-pers__font-card.is-selected');
        if (sf) {
          /* Font size */
          var rawSize = sf.dataset.fontSize;
          if (rawSize !== undefined && rawSize !== '') {
            var parsed = parseInt(rawSize, 10);
            if (!isNaN(parsed) && parsed > 0) fontSize = parsed;
          }

          /* Primary path: CSS block-ID (Liquid-generated rule handles family/weight/style) */
          blockId = sf.dataset.blockId || '';

          if (blockId) {
            /* Clear any previously-set inline font styles so CSS rule wins */
            prevTextEl.style.fontFamily = '';
            prevTextEl.style.fontWeight = '';
            prevTextEl.style.fontStyle  = '';
          } else {
            /* Fallback: metafield-based font card (no blockId) */
            var fam = sf.dataset.fontFamily || sf.dataset.fontFamilyRaw || '';
            if (fam) {
              prevTextEl.style.fontFamily = '"' + fam + '", serif';
            } else {
              var me = FONT_MAP[sf.dataset.fontLabel || ''];
              if (me) { loadGFont(sf.dataset.fontLabel, me.url); prevTextEl.style.fontFamily = me.css; }
            }
            prevTextEl.style.fontWeight = sf.dataset.fontWeight || '400';
            prevTextEl.style.fontStyle  = sf.dataset.fontStyle  || 'normal';
          }
        }
      }

      /* Apply or remove [data-font-block] so Liquid-generated CSS rule activates */
      if (blockId) {
        prevTextEl.setAttribute('data-font-block', blockId);
      } else {
        prevTextEl.removeAttribute('data-font-block');
      }

      var hasContent = isPersonalized && canShowPreview && ((iconType !== 'none' && (iconSymbol || iconUrl)) || text.trim());
      previewEl.classList.toggle('is-visible', !!hasContent);

      /* ── Render icon: image or emoji ── */
      if (iconType === 'image' && iconUrl) {
        /* Image icon — render <img> inside the icon span */
        var existImg = prevIconEl.querySelector('img');
        if (!existImg) {
          existImg = document.createElement('img');
          existImg.style.cssText = 'display:block;object-fit:contain;pointer-events:none;';
          prevIconEl.innerHTML = '';
          prevIconEl.appendChild(existImg);
        }
        existImg.src = iconUrl;
        existImg.alt = '';
        var iSize = (iconSizePx > 0 ? iconSizePx : 60) + 'px';
        existImg.style.width  = iSize;
        existImg.style.height = iSize;
        prevIconEl.textContent = '';
        prevIconEl.appendChild(existImg);
        prevIconEl.style.fontSize = '';
        prevIconEl.style.color    = '';
        prevIconEl.style.display  = 'block';
      } else if (iconSymbol) {
        /* Emoji / text icon */
        prevIconEl.innerHTML = iconSymbol;
        prevIconEl.style.display = '';
        prevIconEl.style.color = colorHex || '#c9a878';
        prevIconEl.style.setProperty('font-size', Math.round(fontSize * 1.2) + 'px', 'important');
      } else {
        prevIconEl.innerHTML = '';
        prevIconEl.style.display = 'none';
      }

      prevTextEl.textContent = text;
      prevTextEl.style.display = text.trim() ? '' : 'none';
      prevTextEl.style.color = colorHex || '#c9a878';
      prevTextEl.style.setProperty('font-size', fontSize + 'px', 'important');

      /* Keep lightbox overlay in sync if it's open on slide 0 */
      if (typeof syncLightboxOverlay === 'function') {
        var lbModal = document.getElementById('PdpZoomModal');
        if (lbModal && lbModal.classList.contains('is-open')) {
          syncLightboxOverlay(0);
        }
      }
    }


    /* ─── LIGHTBOX OVERLAY SYNC ──────────────────── */
    /*
     * Mirrors the personalization preview (icon + text) into the zoom modal overlay.
     * Called automatically on lightbox:open, lightbox:slide, and updatePreview.
     * Only shows overlay when slide index === 0 (first/product photo).
     */
    var lbOverlay = document.getElementById('PdpZoomOverlay');

    function syncLightboxOverlay(slideIndex) {
      if (!lbOverlay) {
        lbOverlay = document.getElementById('PdpZoomOverlay');
        if (!lbOverlay) return;
      }

      var show = (slideIndex === 0) && isPersonalized && canShowPreview;
      if (!show) {
        lbOverlay.classList.add('is-hidden');
        return;
      }
      lbOverlay.classList.remove('is-hidden');

      /* Clone overlay content from the page preview */
      var iconHtml = prevIconEl ? prevIconEl.outerHTML : '';
      var textHtml = prevTextEl ? prevTextEl.outerHTML : '';
      lbOverlay.innerHTML = iconHtml + textHtml;

      /* Scale up the overlay for the larger lightbox image.
       * Page preview targets ~28px text; lightbox shows image at ~88vh,
       * so we scale by 2.5x to keep proportions. */
      var scaleEl = lbOverlay.querySelector('.pdp-pers-preview__text');
      var scaleIcon = lbOverlay.querySelector('.pdp-pers-preview__icon');
      if (scaleEl) {
        var curSize = parseFloat(scaleEl.style.fontSize) || 28;
        scaleEl.style.setProperty('font-size', (curSize * 2.5) + 'px', 'important');
      }
      if (scaleIcon) {
        var curIconSize = parseFloat(scaleIcon.style.fontSize) || 36;
        /* Image icons */
        var iconImg = scaleIcon.querySelector('img');
        if (iconImg) {
          var origW = parseFloat(iconImg.style.width) || 60;
          iconImg.style.width  = (origW * 2.5) + 'px';
          iconImg.style.height = (origW * 2.5) + 'px';
        } else {
          scaleIcon.style.setProperty('font-size', (curIconSize * 2.5) + 'px', 'important');
        }
      }
    }

    /* Listen for lightbox events dispatched from main-product.liquid */
    document.addEventListener('lightbox:open',  function(e) { syncLightboxOverlay(e.detail ? e.detail.index : 0); });
    document.addEventListener('lightbox:slide', function(e) { syncLightboxOverlay(e.detail ? e.detail.index : 0); });
    document.addEventListener('lightbox:close', function()  { if (lbOverlay) lbOverlay.classList.add('is-hidden'); });

    /* ─── THUMBNAIL TRACKING ─────────────────────── */
    document.querySelectorAll('.pdp-thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        canShowPreview = (parseInt(btn.dataset.index || '0', 10) === 0);
        updatePreview();
      });
    });
    document.addEventListener('pers:variantChange', function () { canShowPreview = true; });

    /* ─── ALWAYS-ON PERSONALISATION ──────────────── */
    var currentBasePrice = basePrice;
    /* Panel is always open — set hidden inputs immediately */
    if (modeInput)     modeInput.value     = 'Personalized';
    if (feeIdInput)    feeIdInput.value    = feeVariantId;
    if (feePriceInput) feePriceInput.value = feePrice ? String(feePrice) : '';

    /* ─── PRICE DISPLAY ──────────────────────────── */
    function updatePriceDisplay(price) {
      currentBasePrice = price;
      if (!priceBreakdown) return;
      if (basePriceEl) basePriceEl.textContent = formatMoney(price);
      if (feeTotalEl)  feeTotalEl.textContent  = formatMoney(feePrice > 0 ? price + feePrice : price);
    }
    document.addEventListener('pers:variantChange', function (e) {
      if (e.detail && e.detail.price !== undefined) updatePriceDisplay(e.detail.price);
    });

    /* ─── ICON SELECTION ─────────────────────────── */
    if (iconPicker) {
      var iconCards = iconPicker.querySelectorAll('.pdp-pers__icon-card');
      iconCards.forEach(function (card) {
        card.addEventListener('click', function () {
          iconCards.forEach(function (c) { c.classList.remove('is-selected'); c.setAttribute('aria-pressed', 'false'); });
          card.classList.add('is-selected'); card.setAttribute('aria-pressed', 'true');
          /* Build icon value for order:
           * - emoji: the symbol + name
           * - image: the icon name (image URL not saved to order for clarity)
           * - none: empty */
          var itype = card.dataset.iconType || 'emoji';
          var iname = card.dataset.iconName || '';
          var isym  = card.dataset.iconSymbol || '';
          if (iconInput) {
            if (itype === 'image') {
              iconInput.value = iname;
            } else if (isym) {
              iconInput.value = isym + (iname ? ' ' + iname : '');
            } else {
              iconInput.value = '';
            }
          }
          if (iconNameEl) iconNameEl.textContent = iname;
          updatePreview();
        });
      });
      var ii = iconPicker.querySelector('.is-selected');
      if (ii && iconNameEl) iconNameEl.textContent = ii.dataset.iconName || '';
    }

    /* ─── FONT SELECTION ─────────────────────────── */
    if (fontPicker) {
      var fontCards = fontPicker.querySelectorAll('.pdp-pers__font-card');
      fontCards.forEach(function (card) {
        card.addEventListener('click', function () {
          fontCards.forEach(function (c) { c.classList.remove('is-selected'); c.setAttribute('aria-pressed', 'false'); });
          card.classList.add('is-selected'); card.setAttribute('aria-pressed', 'true');
          if (fontInput) fontInput.value = card.dataset.fontLabel || '';
          updatePreview();
        });
      });
    }

    /* ─── COLOR SELECTION (block-based swatches) ───────── */
    if (colorPicker) {
      var swatches = colorPicker.querySelectorAll('.pdp-pers__color-swatch');
      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          swatches.forEach(function (s) { s.classList.remove('is-selected'); s.setAttribute('aria-pressed', 'false'); });
          sw.classList.add('is-selected'); sw.setAttribute('aria-pressed', 'true');
          document._persColorHex = sw.dataset.colorHex || '';
          if (colorInput)  colorInput.value       = sw.dataset.colorName + ' (' + sw.dataset.colorHex + ')';
          if (colorNameEl) colorNameEl.textContent = sw.dataset.colorName || '';
          updatePreview();
        });
      });
      /* Init with first selected swatch */
      var firstSwatch = colorPicker.querySelector('.is-selected');
      if (firstSwatch) {
        document._persColorHex = firstSwatch.dataset.colorHex || '';
        if (colorInput) colorInput.value = firstSwatch.dataset.colorName + ' (' + firstSwatch.dataset.colorHex + ')';
      }
    }

    

    /* ─── TEXT INPUT ─────────────────────────────── */
    if (textInput) {
      textInput.addEventListener('input',  function () { onTextChange(); updatePreview(); });
      textInput.addEventListener('change', function () { onTextChange(); updatePreview(); });
    }
    function onTextChange() {
      var len = textInput.value.length, left = charLimit - len;
      if (charCountEl) { charCountEl.textContent = len + ' / ' + charLimit; charCountEl.classList.toggle('is-warn', left <= 5); }
      if (hintEl) {
        if (left <= 5 && left > 0) { hintEl.textContent = left + ' character' + (left === 1 ? '' : 's') + ' remaining'; hintEl.classList.remove('is-error'); }
        else if (left === 0)        { hintEl.textContent = 'Character limit reached'; hintEl.classList.add('is-error'); }
        else                        { hintEl.textContent = ''; hintEl.classList.remove('is-error'); }
      }
    }

    /* ─── FORM SUBMIT ────────────────────────────── */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!isPersonalized) {
          [iconInput, fontInput, colorInput, textInput, feeIdInput, feePriceInput].forEach(function (el) { if (el) el.value = ''; });
          return;
        }
        if (textInput && textInput.value.trim() === '') {
          e.preventDefault(); textInput.focus();
          if (hintEl) { hintEl.textContent = 'Please enter your personalisation text.'; hintEl.classList.add('is-error'); }
          return;
        }
        if (feeVariantId && feePrice > 0) { e.preventDefault(); addToCartWithFee(); }
      });
    }

    /* ─── CART API ───────────────────────────────── */
    function addToCartWithFee() {
      var atcBtn    = document.getElementById('PdpAddToCart');
      var variantId = document.getElementById('VariantId') ? parseInt(document.getElementById('VariantId').value, 10) : null;
      var qty       = document.getElementById('PdpQty') ? (parseInt(document.getElementById('PdpQty').value, 10) || 1) : 1;
      if (!variantId) { form.submit(); return; }
      var props = { 'Mode': 'Personalized' };
      if (iconInput  && iconInput.value)  props['Icon']       = iconInput.value;
      if (fontInput  && fontInput.value)  props['Font Style'] = fontInput.value;
      if (colorInput && colorInput.value) props['Text Color'] = colorInput.value;
      if (textInput  && textInput.value)  props['Text']       = textInput.value;
      if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Adding\u2026'; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ id: variantId, quantity: qty, properties: props }) })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (!feeVariantId || !feePrice) return Promise.resolve();
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ id: parseInt(feeVariantId, 10), quantity: qty, properties: { '_For': textInput ? textInput.value : '', '_linked_variant': String(variantId) } }) }).then(function (r) { return r.json(); });
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        if (window.Pera && window.Pera.CartDrawer && window.Pera.CartDrawer.drawer) {
          window.Pera.CartDrawer.refresh().then(function () { window.Pera.CartDrawer.open(); });
        } else { window.location.href = '/cart'; }
        if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = 'Add to Cart'; }
      })
      .catch(function (err) {
        console.error('[Personalization] Cart error:', err);
        if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = 'Add to Cart'; }
        if (hintEl) { hintEl.textContent = 'Something went wrong. Please try again.'; hintEl.classList.add('is-error'); }
      });
    }

    /* ─── DESIGN MODE AUTO-PREVIEW ───────────────── */
    if (window.Shopify && window.Shopify.designMode) {
      isPersonalized = true;
      canShowPreview = true;
      if (textInput && !textInput.value) textInput.value = 'Emma';
      updatePreview();
    }
  } /* end init() */

  /* ─── BOOT ───────────────────────────────────── */
  init();

  /* Re-init after theme editor section reload (fixes stale DOM refs) */
  document.addEventListener('shopify:section:load', function () {
    isPersonalized = false;
    canShowPreview = true;
    init();
  });

})();
